import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Editor, toDoc, toHTML } from 'ngx-editor';
import { DominoInterpretation } from 'src/app/models/domino_models';
import { DominoService } from 'src/app/services/domino.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-factors',
  templateUrl: './create-factors.component.html',
  styleUrls: ['./create-factors.component.css']
})
export class CreateFactorsComponent implements OnInit {

  @ViewChild('text1') text1: ElementRef;
  @ViewChild('text2') text2: ElementRef;
  @ViewChild('text3') text3: ElementRef;
  @ViewChild('text4') text4: ElementRef;
  @ViewChild('text5') text5: ElementRef;


  public editor:Editor;
  public html1;

  public editor2:Editor;
  public html2;

  public editor3:Editor;
  public html3;

  public editor4:Editor;
  public html4;

  public editor5:Editor;
  public html5;

  public id = '';

  constructor(
    private dominoService: DominoService,
  ) { }

  initEditors(){
    // this.editor = new Editor();
    // this.editor2 = new Editor();
    // this.editor3 = new Editor();
    // this.editor4 = new Editor();
    // this.editor5 = new Editor();
    this.text1.nativeElement.innerHTML = toHTML(this.html1);
    this.text2.nativeElement.innerHTML = toHTML(this.html2);
    this.text3.nativeElement.innerHTML = toHTML(this.html3);
    this.text4.nativeElement.innerHTML = toHTML(this.html4);
    this.text5.nativeElement.innerHTML = toHTML(this.html5);
  }

  ngOnInit(): void {
    this.dominoService.getInterpretations().subscribe(
      (resp:DominoInterpretation) => {
        if (resp){
          this.id = resp._id;
          this.html1 = resp.veryLowDesc;
          this.html2 = resp.lowDesc;
          this.html3 = resp.midDesc;
          this.html4 = resp.highDesc;
          this.html5 = resp.veryHighDesc;
          setTimeout(()=>{
            this.initEditors();
          }, 500)
        }
      }
    )
  }

  save(){
    const interpretation: DominoInterpretation = {
      veryLowDesc: this.html1,
      lowDesc: this.html2,
      midDesc: this.html3,
      highDesc: this.html4,
      veryHighDesc: this.html5,
      _id: this.id || null
    }
    this.dominoService.updateInterpretation(interpretation).subscribe(
      (resp:DominoInterpretation) => {
        Swal.fire({
          icon: 'success',
          text: 'Actualizado correctamente',
          timer: 2500
        }).then(
          r => location.reload()
        )
      }
    )
  }

  editHtml(index: number){

    if (index == 1){
      this.editor = new Editor();
      this.editor2.destroy()
      this.editor3.destroy()
      this.editor4.destroy()
      this.editor5.destroy()
    }
    if (index == 2){
      this.editor2 = new Editor();
      this.editor.destroy()
      this.editor3.destroy()
      this.editor4.destroy()
      this.editor5.destroy()
    }
    if (index == 3){
      this.editor3 = new Editor();
      this.editor.destroy()
      this.editor2.destroy()
      this.editor4.destroy()
      this.editor5.destroy()
    }
    if (index == 4){
      this.editor4 = new Editor();
      this.editor.destroy()
      this.editor2.destroy()
      this.editor3.destroy()
      this.editor5.destroy()
    }
    if (index == 5){
      this.editor5 = new Editor();
      this.editor.destroy()
      this.editor2.destroy()
      this.editor3.destroy()
      this.editor4.destroy()
    }

  }

  

}
